import { environment } from '@environments/environment';

export const GET_LATEST_TESTIMONIES_QUERY = (langcode: string, nTestimonies: number, excludeUrl: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_temoignages ?? '',
  body: {
    size: nTestimonies,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
        must_not: [
          {
            terms: {
              url: [excludeUrl],
            },
          },
        ],
      },
    },
    sort: [
      {
        created_timestamp: {
          order: 'desc',
        },
      },
    ],
  },
  _source: ['author', 'image', 'text', 'url'],
});
